import lodash from 'lodash'

const get_debug = function () {
  if (process.env.NODE_ENV == 'development') {
    return console.log.bind(window.console);
  } else {
    return function () {};
  }
};

const toHex = function (string) {
  string = parseInt(string, 10).toString(16);
  string = string.length === 1 ? '0' + string : string;

  return string;
};

const g2_score = function (o, e) {
  if (e == 0 || o == 0) return 0;
  let score = 2 * (o * Math.log(o / e) - (o - e));
  return o >= e ? score : -1 * score;
};

const g2_grade = function (g2) {
  // p-value         0.01   0.02  0.03   0.04   0.05
  // chi_vlaues = [6.617, 5.403, 4.704, 4.214, 3.838]
  if (g2 >= 6.617) {
    return '<=0.01';
  }
  if (g2 >= 5.403) {
    return '<=0.02';
  }
  if (g2 >= 4.704) {
    return '<=0.03';
  }
  if (g2 >= 4.214) {
    return '<=0.04';
  }
  if (g2 >= 3.838) {
    return '<=0.05';
  }
  return '>0.05';
};

const normalize = function (val, min, max, toMin = 8, toMax = 48) {
  return (val - min) * ((toMax - toMin) / (max - min)) + toMin;
};

export const relationUtils = {
  get_g2Values(
    tagsInIdx,
    formulaRstIdxList,
    formulaList,
    dict,
    min_freq,
    g2_cutoff
  ) {
    let localFreq = {
      H: {},
      S: {},
    };
    for (let j of formulaRstIdxList) {
      let f = formulaList[j];
      for (let h of f.H) {
        localFreq.H[h] = localFreq.H[h] ? localFreq.H[h] + 1 : 1;
      }
      for (let s of f.S) {
        localFreq.S[s] = localFreq.S[s] ? localFreq.S[s] + 1 : 1;
      }
    }
    // console.log("localFreq") ; console.log( localFreq )
    let g2s = [];
    let rst = [];
    let hk = Object.keys(localFreq.H);
    let sk = Object.keys(localFreq.S);
    for (let m of hk) {
      let mm = tagsInIdx.filter(e => {
        return e.group == 'H' && e.idx == m;
      });
      if (mm.length != 0) continue;
      let local_freq = localFreq.H[m];
      if (local_freq < min_freq) continue;
      let global_freq = dict.freq.H[m];
      let expect_freq =
        formulaRstIdxList.length * (global_freq / dict.etc.datasize);
      let g2 = g2_score(local_freq, expect_freq);
      if (g2 < g2_cutoff) continue;
      g2s.push(g2);
      rst.push({
        idx: m,
        name: dict.idx2name.H[m],
        group: 'H',
        g2: g2.toFixed(3),
        pvalue: g2_grade(g2),
      });
    }
    for (let n of sk) {
      let nn = tagsInIdx.filter(e => {
        return e.group == 'S' && e.idx == n;
      });
      if (nn.length != 0) continue;
      let local_freq = localFreq.S[n];
      if (local_freq < min_freq) continue;
      let global_freq = dict.freq.S[n];
      let expect_freq =
        formulaRstIdxList.length * (global_freq / dict.etc.datasize);
      let g2 = g2_score(local_freq, expect_freq);
      if (g2 < g2_cutoff) continue;
      g2s.push(g2);
      rst.push({
        idx: n,
        name: dict.idx2name.S[n],
        group: 'S',
        g2: g2.toFixed(3),
        pvalue: g2_grade(g2),
      });
    }

    let g2_min = Math.min(...g2s);
    let g2_max = Math.max(...g2s);
    for (let e of rst) {
      e.norm = normalize(e.g2, g2_min, g2_max).toFixed(2);
    }

    rst.sort((a, b) => b.g2 - a.g2);
    // console.log( g2_min, g2_max)
    return rst;
  },
};

export const setUtils = {
  uniq_arr(arr) {
    return Array.from(new Set(arr));
  },

  intersectionCallback(acc_arr, cur_arr) {
    if (acc_arr && acc_arr.length > 0 && cur_arr && cur_arr.length > 0) {
      return acc_arr.filter(e => cur_arr.includes(e));
    } else {
      return [];
    }
  },

  unionCallback(acc_arr, cur_arr) {
    if (acc_arr && acc_arr.length > 0 && cur_arr && cur_arr.length > 0) {
      return acc_arr.concat(cur_arr);
    } else {
      return [];
    }
  },

  differnceCallback(acc_arr, cur_arr) {
    if (acc_arr && acc_arr.length > 0 && cur_arr && cur_arr.length > 0) {
      return acc_arr.filter(e => !cur_arr.includes(e));
    } else {
      return [];
    }
  },
};

export const helper = {
  log: get_debug(),

  gen_nodesizedegree(n_grade, min = 20, max = 50) {
    let dist = max - min;
    let interval = dist / (n_grade - 1);
    let rrr = [...Array(n_grade).keys()];
    let qqq = rrr.map(i => (min + i * interval).toFixed(2));
    return qqq;
  },

  gen_palette(color, n_grade) {
    let rgb;
    switch (color) {
      case 'R':
        rgb = [255, 0, 0];
        break;
      case 'G':
        rgb = [0, 255, 0];
        break;
      case 'B':
        rgb = [0, 0, 255];
        break;
    }

    let rrr = [...Array(n_grade + 1).keys()];
    let qqq = rrr.map(i => 0 + (i * 1) / n_grade);
    return qqq
      .map(tint => {
        let tmp = [0, 1, 2].map(i =>
          Math.round(tint * rgb[i] + (1 - tint) * 255)
        );
        return '#' + tmp.map(toHex).join('');
      })
      .slice(1);
  },

  getRandomIntInclusive(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min; //최댓값도 포함, 최솟값도 포함
  }, // https://developer.mozilla.org/ko/docs/Web/JavaScript/Reference/Global_Objects/Math/random

  deepClone(object) {
    return lodash.cloneDeep(object)
  },

  deepFreeze(object) {
    // 객체에 정의된 속성명을 추출
    var propNames = Object.getOwnPropertyNames(object);

    // 스스로를 동결하기 전에 속성을 동결

    for (let name of propNames) {
      let value = object[name];

      object[name] =
        value && typeof value === 'object' ? this.deepFreeze(value) : value;
    }

    return Object.freeze(object);
  }, // https://developer.mozilla.org/ko/docs/Web/JavaScript/Reference/Global_Objects/Object/freeze

  isIterable(obj) {
    // checks for null and undefined
    if (obj == null) {
      return false;
    }
    return typeof obj[Symbol.iterator] === 'function';
  }, // https://stackoverflow.com/a/32538867

  // https://gist.github.com/danallison/3ec9d5314788b337b682
  // downloadString("a,b,c\n1,2,3", "text/csv", "myCSV.csv")
  downloadString(text, fileType, fileName) {
    var blob = new Blob([text], { type: fileType });

    var a = document.createElement('a');
    a.download = fileName;
    a.href = URL.createObjectURL(blob);
    a.dataset.downloadurl = [fileType, a.download, a.href].join(':');
    a.style.display = "none";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    setTimeout(function() { URL.revokeObjectURL(a.href); }, 1500);
  },

  float_round( float ){
    let form = 10 ** 4
    return Math.round(float*form)/form
  }
};

// REF
// https://stackoverflow.com/questions/16464485/css-equivalent-for-text-tint